import React from 'react';
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';
import AdminLayout from './AdminLayout';
const ProductDetails = (props) => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Simulcast - Portal</title>
      </Helmet>
      <AdminLayout
        auctionName={props.location.state?.auctionName}
        laneName={props.location.state?.laneName}
        AuctionID={props.match.params.auctionID}
        LaneID={props.match.params.laneID}
        ProductID={props.match.params.productID}
      />
    </React.Fragment>
  );
};

export default observer(ProductDetails);
